// custom components
import { ContentContainer, ExerciseCard } from 'components';
import { useEffect, useState } from 'react';

// user actions
import { useLocation } from 'react-router-dom';

const ExerciseList = () => {
  const location = useLocation();
  const [modules, setModules] = useState([]);
  const [link] = useState([]);

  useEffect(async () => {
    let mounted = true;
    if (mounted) {
      await setModules(location.state.modules);
    }
    if (location.pathname) {
      sessionStorage.setItem('pathnameForPrev', location.pathname);
      sessionStorage.setItem('pathnameForNext', location.pathname);
      sessionStorage.setItem('sessionForPrev', location.state.session);
    }

    return () => {
      mounted = false;
    };
  }, []);
  if (location?.state?.session === 'Glossary') {
    return (
      <ContentContainer title={location.state ? location.state.session : ''}>
        {modules.length > 0 &&
          modules.map((excise, i) => (
            <div key={i}>
              {excise.contents.map((d, key) => {
                return (
                  <a rel="noreferrer" href={d.fileurl} target="_blank" key={key}>
                    {d.filename}
                  </a>
                );
              })}
            </div>
          ))}
      </ContentContainer>
    );
  }

  return (
    <ContentContainer title={location.state ? location.state.session : ''}>
      {modules?.length === 0 && (
        <h4 style={{ textAlign: 'center', color: 'red' }}>No data is present</h4>
      )}
      {location?.state?.session === 'eBook'
        ? ' '
        : modules?.length > 0 &&
          modules
            ?.filter(excise => excise.visible === 1)
            ?.map((excise, i) => {
              link.push({ id: excise.instance, name: excise.name, visible: excise.visible });

              return (
                <ExerciseCard
                  courseID={
                    location?.state?.courseID && location.state.courseID !== 'undefined'
                      ? location.state.courseID
                      : sessionStorage.getItem('activityInstance')
                  }
                  instance={excise.instance}
                  type={true}
                  key={i}
                  links={link}
                  session={excise?.name}
                />
              );
            })}
    </ContentContainer>
  );
};

export default ExerciseList;
